import { useSuspenseQuery } from '@tanstack/react-query';
import { useGetOrderProductGroupsApi } from '@/clients/orderProducts/orderProductsClient';

export function getOrderProductGroupsQueryKey(orderId: string) {
    return ['order-product-group', 'get', orderId];
}

export const useOrderProductGroup = (orderId: string, fetchOnce = false) => {
    const { getOrderProductGroups } = useGetOrderProductGroupsApi();

    return useSuspenseQuery({
        queryKey: getOrderProductGroupsQueryKey(orderId),
        queryFn: () => getOrderProductGroups(orderId),
        refetchOnWindowFocus: false,
        select: data => data[0],
        ...(fetchOnce && { staleTime: Infinity, cacheTime: Infinity }),
    });
};
